import React, { useCallback, useEffect, useMemo, useState } from "react";

function ETAAircraft({
  callsign,
  anchor,
  eta,
  hasRadarTrack = true,
  type = "L",
  selectAircraft
}) {
  let shouldFill = false;
  let color = "#00FD98";

  switch (type) {
    case "H":
      shouldFill = true;
  }

  if (!hasRadarTrack) {
    color = "#FF9832";
  }

  const handleEtaAircraftClick = useCallback(() => {
    selectAircraft(callsign);
  }, [selectAircraft]);

  return (
    <>
      <text
        x="22"
        y={95 - anchor}
        fill="#00FD98"
        textAnchor="end"
        alignmentBaseline="central"
        fontSize={1.1}
        onClick={handleEtaAircraftClick}
        className="eta-aircraft-label"
        // fontWeight="bold"
      >
        {callsign}
      </text>
      {(type === "S" || type === "5") && (
        <>
          <path
            d={`M 22.0 ${95 - anchor - 0.1}, 22.4 ${95 - anchor - 0.1}, 22.4 ${95 - anchor + 0.1}, 22.0 ${95 - anchor + 0.1}`}
            stroke={color}
            fill={color}
            strokeWidth={0.07}
          />
          {type === "5" && (
            <path
              d={`M 22.13 ${95 - anchor - 0.25}, 22.27 ${95 - anchor - 0.25}, 22.27 ${95 - anchor + 0.25}, 22.13 ${95 - anchor + 0.25} Z`}
              stroke={color}
              fill={"#000"}
              strokeWidth={0.05}
            />
          )}
        </>
      )}
      {type !== "S" && type !== "5" && (
        <path
          d={`M 22.0 ${95 - anchor - 0.3}, 22.35 ${95 - anchor}, 22.0 ${95 - anchor + 0.3}`}
          stroke={color}
          fill={shouldFill ? color : "none"}
          strokeWidth={0.07}
        />
      )}
      
      {/* {Math.abs(anchor - eta) > 0.5 && ( */}
        <path
          d={`M 22.5 ${95 - anchor}, 23.25 ${95 - eta}`}
          fill="transparent"
          stroke={color}
          strokeWidth={0.07}
        />
      {/* )} */}
    </>
  );
}

export default ETAAircraft;